export const es: Record<string, string> = {
  app_subtitle: 'Encuentra tu próximo juego de la lista de deseos en función de tu tiempo y presupuesto.',
  steam_id_placeholder: 'Introduce tu ID Steam64 (ej. 76561198012345678)',
  fetch_wishlist: 'Obtener Lista',
  landing_help: 'Tu perfil y lista de Steam deben ser <strong>públicos</strong>. Encuentra tu ID en <a href="https://steamid.io" target="_blank" rel="noopener">steamid.io</a>.',
  landing_disclaimer: 'Esto es un proyecto creado por fans, no afiliado a <a href="https://store.steampowered.com" target="_blank" rel="noopener">Valve</a>, <a href="https://www.gog.com" target="_blank" rel="noopener">GOG</a> ni <a href="https://howlongtobeat.com" target="_blank" rel="noopener">HowLongToBeat</a>. Código fuente en <a href="https://github.com/t0mg/howlong">GitHub</a>.',
  loading_games_enriched: '{count} / {total} juegos procesados ({percent}%)',
  loading_throttled_title: 'Steam está limitando las solicitudes',
  loading_waiting: 'Esperando {time}...',
  loading_stop: 'Detener y Mostrar',
  loading_stopping: 'Deteniendo y preparando resultados...',
  loading_fetching_appid: 'Obteniendo AppIDs...',
  loading_fetching_prices: 'Obteniendo precios...',
  loading_fetching_details: 'Obteniendo detalles...',
  loading_fetching_details_count: 'Obteniendo detalles para {count} juegos...',
  loading_enriching: 'Enriqueciendo con HowLongToBeat...',
  loading_enriching_gog: 'Enriqueciendo con GOG...',
  error_wishlist_private: 'La lista de deseos está vacía o es privada.',
  error_no_details: 'No se pudieron obtener detalles para tus juegos.',
  error_unexpected: 'Ocurrió un error inesperado.',
  error_try_again: 'Intentar de Nuevo',
  dashboard_change_id: '← Cambiar ID de Steam',
  dashboard_lucky: 'Voy a Tener Suerte',
  dashboard_insights: 'Estadísticas',
  dashboard_filter_label: 'Filtro:',
  dashboard_filter_all: 'Todas las Categorías',
  dashboard_sort_label: 'Ordenar por:',
  dashboard_match_info: 'Datos HLTB encontrados: {found} / {total}',
  dashboard_hltb_warning: '⚠️ Algunos datos HLTB no se pudieron obtener por errores del servidor. Recarga para intentar de nuevo.',
  lucky_title: 'Voy a Tener Suerte',
  lucky_desc: '¿No sabes a qué jugar? Deja que el azar decida.',
  lucky_too_long: 'Más corto',
  lucky_not_in_mood: 'Diferente',
  lucky_too_expensive: 'Más barato',
  lucky_ok: 'Cerrar',
  lucky_empty: '¡No hay más juegos para sugerir!',
  stats_games: 'Juegos',
  stats_main: 'Historia',
  stats_main_extra: 'Historia + Extras',
  stats_completionist: 'Completista',
  stats_value: 'Valor de la Lista',
  stats_savings: 'Ahorro por Ofertas',
  sort_priority: 'Prioridad',
  sort_dateAdded: 'Fecha de Añadido',
  sort_name: 'Nombre',
  sort_hltbMain: 'Duración (Principal)',
  sort_hltbMainExtra: 'Duración (Principal+)',
  sort_hltbCompletionist: 'Duración (100%)',
  sort_priceFinal: 'Precio',
  sort_discountPercent: 'Descuento',
  settings_title: 'Opciones',
  settings_desc: 'Gestiona tus preferencias y la caché local.',
  settings_region_label: 'Región de Steam',
  settings_region_desc: 'Selecciona la región para ver precios exactos.',
  settings_lang_label: 'Idioma',
  settings_lang_desc: 'Selecciona tu idioma preferido.',
  settings_clear_hltb_label: 'Borrar Datos HLTB',
  settings_clear_hltb_desc: 'Borra duraciones de juegos para volver a obtenerlas.',
  settings_clear_hltb_btn: 'Borrar HLTB',
  settings_cleared: '¡Borrado!',
  settings_clear_steam_label: 'Borrar Datos Steam',
  settings_clear_steam_desc: 'Borra los metadatos almacenados de Steam.',
  settings_clear_steam_btn: 'Borrar Steam',
  settings_clear_gog_label: 'Borrar datos de GOG',
  settings_clear_gog_desc: 'Eliminar metadatos y precios de GOG almacenados en caché.',
  settings_clear_gog_btn: 'Borrar GOG',
  settings_clear_hidden_label: 'Borrar juegos ocultos',
  settings_clear_hidden_desc: 'Mostrar todos los juegos que fueron ocultados previamente.',
  settings_clear_hidden_btn: 'Limpiar',
  settings_hard_reset_label: 'Restablecer Todo',
  settings_hard_reset_desc: 'Borrar toda la caché global de la aplicación.',
  settings_hard_reset_btn: 'Restablecer',
  settings_hard_reset_confirm: '¿Estás seguro?',
  settings_close: 'Cerrar',
  insights_title: 'Estadísticas',
  insights_desc: 'Análisis profundo de tu lista de deseos.',
  insights_avg_price_hr: 'Precio Medio/Hr',
  insights_oldest_entry: 'Juego Más Antiguo',
  insights_top_genre: 'Género Principal',
  insights_total_story: 'Historia Total',
  insights_chart_duration: 'Distribución por Duración (Hrs)',
  insights_chart_price: 'Distribución por Precio ({currency})',
  insights_chart_genre: 'Géneros Populares',
  insights_chart_year: 'Añadidos por Año',
  insights_chart_store: 'Mejor Precio: Steam vs GOG',
  game_coming_soon: 'Próximamente',
  game_demo: 'Demo',
  game_demo_avail: 'Demo disp.',
  game_added: 'Añadido {date}',
  game_free: 'Gratis',
  game_unavailable: 'No disponible',
  game_cached: '(caché)',
  game_price_na: 'Precio N/D',
  game_no_hltb: 'Sin datos HLTB',
  game_hltb_pending: 'Buscando...',
  game_link_steam: 'Steam',
  game_link_hltb: 'HLTB',
  game_link_gog: 'GOG',
  dashboard_filter_hidden: 'Juegos ocultos',
  game_link_hide: 'Ocultar',
  game_link_unhide: 'Mostrar',
  hide_confirm_title: 'Ocultar juego',
  hide_confirm_desc: '¿Estás seguro de que quieres ocultar este juego? Se eliminará de tus listas pero se seguirá rastreando.',
  hide_confirm_btn: 'Ocultar',
  hide_cancel_btn: 'Cancelar',
};
